<template>
  <CModal
    :color="color"
    :show.sync="showModal"
    size="lg"
    class="basic-modal-color"
  >   
    <template #header>
      <CRow style="width: 100%; height: 35px;">
        <CCol md="7">
          <h5 class="modal-title">{{title}}</h5>
        </CCol>
        <CCol md="3">
          <h6 class="modal-title" style="margin-top: 5px;"> Invitados Asignados: {{assignedTickets}}</h6>
        </CCol>
        <CCol md="2">
          <CSelect
            :value.sync="tableSelect" 
            :options="tablesOptions"
            @change="changeTable"
          />            
        </CCol>
      </CRow>
      <CButtonClose @click="showModal = false"/>            
    </template>
    <CRow>      
      <CCol md="12">
        <CDataTable
          id="Mesa"
          :hover="hover"
          :striped="striped"
          :border="border"
          :small="small"
          :fixed="fixed"
          :items="guestsTable"
          :fields="fields"
          :dark="dark"
          :noItemsView="{ noResults: 'No se encontraron elementos', noItems: 'Sin Invitados' }"
        >
          <template #position="{item}"><td class="text-center w80" style="font-size: 12px;">{{item.position}}</td></template>
          <template #name="{item}"><td class="text-left"><b style="font-size: 12px;">{{item.name}}</b></td></template>
          <template #last_name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 12px;">{{item.last_name}}</b></td></template>
          <template #nickname="{item}"><td class="text-center w150" style="font-size: 12px;">{{item.nickname}}</td></template>
          <template #tickets="{item}"><td class="text-center w100" style="font-size: 12px;">{{item.tickets}}</td></template>     
          <template #table="{item}">
            <td class="text-center w100" style="font-size: 12px;">
              <template v-if="item.table != ''">
                {{item.table}}
              </template>
              <template v-else>
                -
              </template>                
            </td>
          </template>         
          <template #is_confirm="{item}">
            <td class="text-center w100" style="font-size: 16px;">
              <template v-if="item.is_confirm == 0">
                <CBadge color="warning">Pendiente</CBadge>
              </template>
              <template v-else-if="item.is_confirm == 2">
                <CBadge color="danger">No</CBadge>
              </template>
              <template v-else>
                <CBadge color="success">Si</CBadge>
              </template>          
            </td>
          </template>
        </CDataTable>        
      </CCol>              
    </CRow>   
    <CRow>      
      <CCol md="12">
        <CDataTable
          :hover="hover"
          :striped="striped"
          :border="border"
          :small="small"
          :fixed="fixed"
          :items="guestsToAssign"
          :fields="fields"
          :dark="dark"
          :noItemsView="{ noResults: 'No se encontraron elementos', noItems: 'No se encontraron elementos' }"
        >
          <template #position="{item}">
            <td class="text-center w80">
              <input type="checkbox" v-model="idsGuests" :value="item.id" :id="'check'+item.id"> 
            </td>
          </template>
            <template #name="{item}"><td class="text-left"><b style="font-size: 12px;">{{item.name}}</b></td></template>
            <template #last_name="{item}"><td class="text-left"><b style="font-size: 12px;">{{item.last_name}}</b></td></template>
            <template #nickname="{item}"><td class="text-center w150" style="font-size: 12px;">{{item.nickname}}</td></template>
            <template #tickets="{item}"><td class="text-center w100" style="font-size: 12px;">{{item.tickets}}</td></template>              
            <template #table="{item}">
              <td class="text-center w100" style="font-size: 12px;">
                <template v-if="item.table != ''">
                  {{item.table}}
                </template>
                <template v-else>
                  -
                </template>                
              </td>
            </template>
            <template #is_confirm="{item}">
              <td class="text-center w100" style="font-size: 14px;">
                <template v-if="item.is_confirm == 0">
                  <CBadge color="warning">Pendiente</CBadge>
                </template>
                <template v-else-if="item.is_confirm == 2">
                  <CBadge color="danger">No</CBadge>
                </template>
                <template v-else>
                  <CBadge color="success">Si</CBadge>
                </template>          
              </td>
            </template>
        </CDataTable>        
      </CCol>              
    </CRow>      
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cerrar</CButton>
      <CButton @click="updateTable" :color="color">Asignar</CButton>
    </template>
  </CModal>
</template>

<script>
import store from '@/store';
import ws from '@/services/events_guests';
import ws_table from '@/services/events_tables';

export default {
  name: 'AssignTableModal',
  props: {
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'N°',_style:"font-size: 12px;"},
          {key: 'name', label: 'Nombre',_style:"font-size: 12px;"},
          {key: 'last_name', label: 'Apellido',_style:"font-size: 12px;"},
          {key: 'nickname', label: 'Apodo',_style:"font-size: 12px;"},
          {key: 'tickets', label: 'Invitados',_style:"font-size: 12px;"},
          {key: 'table', label: 'Mesa',_style:"font-size: 12px;"},
          {key: 'is_confirm', label: 'Confirmación',_style:"font-size: 12px;"},
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Enviar Invitación",
      color: "info",
      submitted: false,      
      guestsTable: [],      
      guestsToAssign: [],      
      tablesOptions: [],
      idsGuests: [],
      tableSelect: "",
      event_id: 0,
      assignedTickets: 0,
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    async showAssignModal (event_id) {
      this.loading();
        this.showModal = true;
        this.color = "info";
        this.title = 'Asignar Mesa';        
        this.submitted = false;        
        this.event_id = event_id;
        this.idsGuests = [];

        let response_tables = await ws_table.get(event_id);
        if(response_tables.type == "success"){
          this.tablesOptions = await this.$parseSelectOptions(response_tables.data, "id", "name",[]);
          this.tableSelect = this.tablesOptions[0].value;
        }    

        this.changeTable();
        
        this.changeToAssignTable();

      this.loaded();

    },
    async changeTable () {
      this.loading();
        let filters = this.getFiltersGuestAssign();
      
        let response = await ws.get(filters);
        if(response.type == "success"){
          this.guestsTable = response.data;
          this.assignedTickets = response.data.reduce((x, element) => x + element.tickets,0);
        }
      this.loaded();
    },
    async changeToAssignTable () {
      this.loading();
        let filtersTo = this.getFiltersGuestToAssign();
        
        let responseTo = await ws.get(filtersTo);
        if(responseTo.type == "success"){
          this.guestsToAssign = responseTo.data;
        }
      this.loaded();
    },
    getFiltersGuestToAssign(){
      let filters = {
        event_id: this.event_id,
        is_confirm: "",
        event_table_id: 0,
        exclude: ["rejected"]
      };

      return filters;
    },
    getFiltersGuestAssign(){
      let filters = {
        event_id: this.event_id,
        is_confirm: "",
        event_table_id: this.tableSelect,
      };

      return filters;
    },
    async updateTable(){
      this.loading();

        let params = {
          event_id: this.event_id,
          event_table_id: this.tableSelect,
          ids: this.idsGuests,
        }
        let response = await ws.assignTable(params);
        
        this.showToast(response.type, response.message);
        if(response.type == "success"){
          this.$emit("refreshItems");
          this.changeTable();
          this.changeToAssignTable();
          this.idsGuests = [];
        }                              
    },
    closeModal () {
      this.showModal = false;
      this.submitted = false
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
</style>